module.exports = "../images/kayaking-on-lake-home.jpg?v=9b3a0e3";